import { useAudienceQuery } from '@occc/graphql';

export const useGetAudienceById = (audienceId?: string, chainIdEquals?: string) => {
  const response = useAudienceQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    skip: !audienceId,
    variables: {
      filter: {
        uuidEquals: audienceId,
        ...(chainIdEquals ? { chainIdEquals } : {}),
      },
    },
  });

  const node = response.data?.audiences.edges[0]?.node;

  return {
    ...response,
    data: node,
    loaded: !!node,
  };
};
